import React, { useState } from "react";
import ProjectCard from "./ProjectCard";
import projects from "../data/projects";

const Projects = () => {
  const [openProject, setOpenProject] = useState(null);

  return (
    <section className="bg-white px-6 pb-12 text-zinc-950 dark:bg-zinc-950 dark:text-white">
      <div className="mx-auto mb-3 w-full max-w-3xl text-left">
        <h2 className="text-xl font-semibold">Projects</h2>
      </div>

      <div className="mx-auto flex w-full max-w-3xl flex-col items-center">
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            project={project}
            isOpen={openProject}
            setOpenProject={setOpenProject}
          />
        ))}
      </div>
    </section>
  );
};

export default Projects;
